import LoadingMini_ from './LoadingMini';
import LoadingFull_ from './LoadingFull';
import Preloader_ from './Preloader';

export const LoadingMini = LoadingMini_;
export const LoadingFull = LoadingFull_;
export const Preloader = Preloader_;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js